import { register, findAll } from '../../../../Javascript/Sysmex/Utils'

const Navigation = el => {
  const componentPrefix = el.dataset.componentprefix
  const navigationItemFirstLink = findAll(`.${componentPrefix}navigationItemFirstLink`, el)
  const hasChildren = `${componentPrefix}hasChildren`

  const clickItem = (e) => {
    const clickedElement = e.currentTarget
    e.preventDefault()
    if (clickedElement.parentNode.classList.contains(hasChildren)) {
      clickedElement.parentNode.classList.toggle(`${componentPrefix}active`)
    }
  }

  navigationItemFirstLink.forEach(element => {
    element.addEventListener('click', clickItem)
  })
}

register('Navigation', Navigation)
